import { useMutation } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { previewNotificationTemplate } from "../../api/apiNotificationTemplates";
import parseError from "../../utils/parseError";

export const usePreviewNotificationTemplate = () => {
    const mutation = useMutation({
        mutationFn: ({ id, data }) => previewNotificationTemplate(id, data),
        onError: (error) => {
            toast.error(parseError(error) || "Failed to render preview");
        },
    });

    return mutation;
};
